import Reestr from './Reestr';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux'
import {reestrActions} from './reducer';

const mapStateToProps = ({reestr}) => reestr;
const mapDispatchToPtops = dispatch => bindActionCreators(reestrActions, dispatch);

export default connect(mapStateToProps, mapDispatchToPtops)(Reestr);